import React, { memo } from 'react';

import { mainInfo } from '@consts';

import { JobItem } from './JobItem';

import { JobListContainer } from './JobList.styled';

import { getBlockState } from '../JobBlock.utils';

import { JobListProps } from './JobList.types';

export const JobList = memo(({ active, onClick }: JobListProps) => {
  const isSliderActive = getBlockState(active);
  return (
    <JobListContainer>
      {mainInfo.EXPERIENCE_INFO.map((one) => (
        <JobItem
          key={one.id}
          {...one}
          onClick={onClick}
          short={isSliderActive}
          active={active === one.id}
        />
      ))}
    </JobListContainer>
  );
});
